module.exports = __webpack_public_path__ + "static/media/23a Mount.016b97cd.jpg";